<template>
  <div class="content">
    <div class="tool_top">
      <SearchInput :showSearch="false"></SearchInput>
    </div>
    <div class="content_body">
      <!-- 信息查询 -->
      <div class="form-warp">
        <div class="form-panel">
          <div class="form-panel-top">
            <span class="top-title">找关系</span>
            <div class="top-btn">
              <el-button class="text_btn reset_btn" type="text" icon="el-icon-delete" size="small"
                @click="resetForm('dynamicValidateForm')">清空所有</el-button>
            </div>
          </div>
          <div class="form-content">
            <el-form ref="dynamicValidateForm" label-width="100%" label-position="left" class="demo-dynamic"
              size="small">
              <el-form-item v-for="(domain, index) in domains" :label="domain.field + (index + 1)" :key="index"
                :prop="domains[index].param">
                <el-input v-model="domain.param"></el-input>
                <el-button v-if="index == domains.length - 1" class="text_btn delete_btn" type="text"
                  @click.prevent="removeDomain(domain)" icon="el-icon-delete"></el-button>
              </el-form-item>
              <el-form-item>
                <el-button class="text_btn" type="text" icon="el-icon-circle-plus"
                  @click="addDomain">新增关系目标节点</el-button>
              </el-form-item>
              <el-form-item>
                <el-button class="block_btn" @click="submitForm('dynamicValidateForm')">开始分析</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="form-result-panel">
          <div class="chart">
            <GraphChart :detailType="detailType" :chartInfo="graphInfo"></GraphChart>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import SearchInput from './components/search_input.vue';
import GraphChart from './components/charts/graphChart.vue';
export default {
  name: 'relativeNetwork',
  components: {
    SearchInput,
    GraphChart,
  },
  data() {
    return {
      detailType: '4',
      graphInfo: { id: 'network_4' },
      domains: [],
    };
  },
  created() {
    this.domains = [
      { field: '目标主体', param: '' },
      { field: '目标主体', param: '' },
      { field: '目标主体', param: '' },
    ]
  },
  watch: {
    // filterText(val) {
    //   this.$refs.tree.filter(val);
    // },
  },
  methods: {
    exportData() {
      // 导出数据
    },
    handleClick() {
      // 获取搜索结果
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      var index = this.domains.indexOf(item)
      if (index !== -1) {
        this.domains.splice(index, 1)
      }
    },
    addDomain() {
      this.domains.push({
        field: '目标主体',
        param: ''
      });
    }
  },
};
</script> 
<style lang="less" scoped>
@import "../../assets/style/portrait.less";

.form-warp {
  height: 100%;
  padding: 0 15px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;

  .form-panel {
    width: 30%;
    min-width: 320px;
    margin-bottom: 15px;
    background: #fff;
    border: 1px solid #d9d9d9;

    .form-panel-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0 10px;
      margin: 0 15px;
      border-bottom: 1px solid #d9d9d9;

      .top-title {
        font-size: 16px;
        color: #212121;
        line-height: 24px;
        font-weight: 600;
      }
    }

    .form-content {
      height: calc(100% - 80px);
      padding: 15px;

      /deep/.el-form {
        .el-form-item {
          display: flex;
          flex-wrap: wrap;

          .el-form-item__label {
            font-size: 14px;
            color: #212121;
            font-weight: 600;
          }

          .el-form-item__content {
            margin-left: 0 !important;
            width: 100%;
            text-align: left;
          }
        }
      }
    }
  }

  .form-result-panel {
    width: calc(70% - 20px);
    max-width: calc(100% - 340px);
    margin-bottom: 15px;
    background: #fff;
    border: 1px solid #d9d9d9;
  }
}

/deep/.el-button {
  &.text_btn {
    border: none;
    padding: 0;
    font-size: 14px;
  }

  &.reset_btn {
    color: #999999;
    line-height: 21px;
    font-weight: 400;
  }

  .el-icon-delete {
    color: #B2B2B2;
  }

  &.delete_btn {
    position: absolute;
    top: -20px;
    right: 0px;
    font-size: 14px;
  }

  &.block_btn {
    width: 100%;
    background: #4FA1A4;
    border-radius: 2px;
    color: #fff;
  }
}
</style>